export default "__VITE_ASSET__Cgx1F9Ax__"